<template>

  <div v-if="getPermission.acnit.view">

    <ccr-log-form ref="CcrLogForm" mode="create" :on-update="updateLog"/>
    <ccr-log-form ref="CcrLogUpdateForm" mode="update" :on-update="updateLog"/>

    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <span class="heading2">{{photoTitle}}</span>
        <calling-api path="/api/w/ccr/photo/getCCRPhoto">
        <div v-if="photos.length === 0">
          <h3>You don't have any photos from CCR Log</h3>
        </div>
        <div v-else>
          <view-image  :key="p.imgUrl" :src="p.imgUrl" v-for="p in photos">
           <div v-if="!isLoading" class="space">
              <h3>Type: {{p.title}}</h3>
              <p>File Name: {{getPhotoName(p)}}</p>
            </div>
            <div v-if="isLoading" class="space">
              <p>File Name: {{getPhotoName(p)}}</p>
              <p>{{p.refTimeStamp}}</p>
            </div>            
          </view-image>
        </div>
          
        </calling-api>
      </md-dialog-content>
      <md-dialog-actions>
        <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"
                                  v-if="isLoading"/>
        <md-button class="md-primary" @click="isPictureModalShowing = false; isLoading = false;">Close</md-button>      </md-dialog-actions>
    </md-dialog>


    <md-card  class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <!--
          <div class="md-layout-item md-size-5">

          </div>
          -->
          <!--<div style="position:relative; margin-left:25px;"> -->.
          <div class="f1">  
              <!-- Col 1 Row 1 -->
              <div class = "inputBoxSpace" >    
              <auto-complete-master-data-select id="recwin"
                                                group="REC_WINDOW"
                                                label="Yard"
                                                :init-value="searchRequest.yard"
                                                :watchValueId="searchRequest.yard"
                                                :on-item-changed="handleYardChanged"
                                                >
              </auto-complete-master-data-select>
              </div>
            <!-- Col 2 Row 1 -->
            <!--<div style="position:relative; margin-top:-66px; margin-left:208px; width:200px;">-->
            <div class="c2r1">  
            <div class = "inputBox" >
              <md-field>
                <label>Plate No.</label>
                <md-input v-model="searchRequest.plateNo" @keyup.enter="doSearch('0')"/>
              </md-field>
            </div>
            </div>
            <!-- Col 3 Row 1 -->
            <!--<div style="position:relative; margin-left:415px; margin-top:-66px; width:200px;">-->
            <div class="c3r1">  
            <div class = "inputBox" >
              <md-field>
                <label>Container No.</label>
                <md-input v-model="searchRequest.containerNo" @keyup.enter="doSearch('0')"/>
              </md-field>
            </div>
            </div>
            <!-- Col 4 Row 1 --> 
            <!--<div style="position:relative; margin-left:620px; margin-top:-66px; width:200px;">-->
            <div class="c4r1">  
            <div class = "inputBox" >
              <md-field>
                <label>Chassis No.</label>
                <md-input v-model="searchRequest.chassisNo" @keyup.enter="doSearch('0')"/>
              </md-field>
            </div>
            </div>
            <!-- Col 5 Row 1 -->
            <!--<div style=" position:relative; margin-left:825px; margin-top:-66px; width:200px;">-->
            <div class="c5r1"> 
              <div class = "inputBoxSpace" >    
              <auto-complete-master-data-select id="gateType"
                                                group="CCR_GATETYPE"
                                                label="Gate Type"
                                                :init-value="searchRequest.gateType"
                                                :watchValueId="searchRequest.gateType"
                                                :on-item-changed="handleGateTypeChanged"
                                                >
            </auto-complete-master-data-select>
            </div>
            </div>  
            <!-- Col 1 Row 2 -->
            <!--<div style=" position:relative; margin-left:1030px; margin-top:-66px; width:200px;">-->
            <div class="c1r2">  
            <div class = "inputBox" >
              <md-field>
                <label>Gate No.</label>
                <md-input v-model="searchRequest.gateNo" @keyup.enter="doSearch('0')"/>
              </md-field>
            </div>
            </div>
            <!-- Col 2 Row 2 -->
            <!--<div style="position:relative; margin-top:10px; width:200px; position:relative;">-->
            <div class="c2r2">  
              <div class = "inputBox">
                <datepicker v-model="logStartDate">
                <label>Log Date</label>
                </datepicker>
              </div>
            </div>
            <!-- Col 3 Row 2 -->
            <!--<div style="position:relative; margin-top:-66px; margin-left:208px;width:200px;">-->
            <div class="c3r2">  
                <div class = "inputBox">
                  <datepicker v-model="logEndDate">
                  <label>To</label>
                  </datepicker>
                </div>
            </div>
            <!-- Col 4 Row 2 -->
            <!--<div style="position:relative; margin-top:-66px; margin-left:415px;width:200px;"> -->
            <div class="c4r2">  
              <div class = "inputBoxSpace" >    
              <auto-complete-master-data-select id="cntrType"
                                                group="CCR_CNTRTYPE"
                                                label="Container Type"
                                                displayType="idOnly"
                                                :reverse=true
                                                :init-value="searchRequest.containerType"
                                                :watchValueId="searchRequest.containerType"
                                                :on-item-changed="handleContainerTypeChanged"
                                                >
              </auto-complete-master-data-select>
              </div>
            </div>
            <!-- Col 5 Row 2 -->
            <!--<div style="position:relative; margin-top:-66px; margin-left:620px;width:200px;">-->
            <div class="c5r2">  
              <div class = "inputBoxSpace" >    
              <auto-complete-master-data-select id="statusType"
                                                group="CCR_STATUSTYPE"
                                                label="Status Type"
                                                :init-value="searchRequest.statusType"
                                                :watchValueId="searchRequest.statusType"
                                                :on-item-changed="handleStatusTypeChanged"
                                                >
              </auto-complete-master-data-select>
              </div>
            </div>  

            <!-- Col 6 Row 2 -->
            <!--<div style="position:relative; margin-top:-66px; margin-left:620px;width:200px;">-->
            <div class="c6r2">  
                <div class = "inputBox">
                <md-field>
                  <label>Inbound Shipment</label>
                  <md-input v-model="searchRequest.inboundShipment" @keyup.enter="doSearch('0')"/>
                </md-field>
                </div>
            </div>  

          </div>
          <!--<div style="margin-top:15px; margin-left:30px; width:500px; position:relative;">-->
          <div class="f2">  
            <md-checkbox v-model="showOnlyProblem" id="showOnlyProblem">
              <label>Show Only Problem Items</label>
            </md-checkbox>
          </div>
    <div class="f3">
      <md-button class="md-raised optionExtender" 
          @click="doNew">New</md-button>
      <md-button class="btn-search-schedule md-primary md-raised optionExtender" 
          @click="doSearch">Search</md-button>
       <md-button class="md-raised gap" 
          @click="doClear">Clear</md-button>       
       <md-button
          class="custButtonOutbound md-raised"
          @click="doDownloadExcel"
          :disabled="!getDownloadCond"
        > 
        Download
        </md-button>
    </div>


        </div>
      </md-card-content>
    </md-card>
    <br/>

    <md-progress-bar  v-if="isdownloadzip" id="pb" style="display:''" md-mode="indeterminate"/>

    <callingApiCenter path="/api/w/ccr/data/getCCRLog">

      <pagination :items="filteredRows">
        <template slot-scope="{pageItems}">
          <md-card class="data-table-container">
             <div class="outer-container">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <!--<th class="header-cell w2"></th>-->
                      <!--<th class="header-cell w9">Appointment Id</th>-->
                      <th class="header-cell w4" v-on:click="sortFunction('logId')">Log ID</th>
                      <th class="header-cell w4" v-on:click="sortFunction('yard')">Yard</th>
                      <th class="header-cell w4" v-on:click="sortFunction('gateTypeDesc')">Gate Type</th>
                      <th class="header-cell w4" v-on:click="sortFunction('gateNo')">Gate No</th>
                      <th class="header-cell w5" v-on:click="sortFunction('statusTypeDesc')">Status Type</th>
                      <!-- <th class="header-cell w5">Day Desc</th> -->
                      <th class="header-cell w4" v-on:click="sortFunction('logDateTime')">Log Date</th>
                      <th class="header-cell w4" v-on:click="sortFunction('logDateTime')">Log Time</th>
                      <!--<th class="header-cell w5">Sort time</th>-->
                      <th class="header-cell w7" v-on:click="sortFunction('plateNo')">Plate No</th>
                      <th class="header-cell w7" v-on:click="sortFunction('plateImage')">Plate Image</th>
                      <th class="header-cell w7" v-on:click="sortFunction('containerNo')">Container No</th>
                      <th class="header-cell w6" v-on:click="sortFunction('containerType')">Container Size</th>
                      <th class="header-cell w6" v-on:click="sortFunction('containerType')">Container Size Desc</th>
                      <th class="header-cell w6" v-on:click="sortFunction('containerType')">Container Size ID</th>
                      <th class="header-cell w7" v-on:click="sortFunction('containerImage')">Container Image</th>
                      <th class="header-cell w7" v-on:click="sortFunction('chassisNo')">Chassis No</th>
                      <th class="header-cell w7" v-on:click="sortFunction('chassisImage')">Chassis Image</th>
                      <th class="header-cell w6" v-on:click="sortFunction('scaleWeight')">Scale Weight</th>
                      <th class="header-cell w5" v-on:click="sortFunction('logStatus')">Status</th>
                      <th class="header-cell w10" v-on:click="sortFunction('status')">CCR Status</th>
                      <th class="header-cell w7" v-on:click="sortFunction('inboundShipment')">Inbound Shipment</th>
                      <th class="header-cell w7" v-on:click="sortFunction('seqNo')">Seq Num</th>
                      <th class="header-cell w10" v-on:click="sortFunction('containerNo')">CtnrNo In</th>
                      <th class="header-cell w10" v-on:click="sortFunction('plateNo')">PlateNo In</th>
                      <th class="header-cell w10" v-on:click="sortFunction('chassisNo')">ChassisNo In</th>
                      <th class="header-cell w7" v-on:click="sortFunction('createdAt')">Info Rec C Date</th>
                      <th class="header-cell w7" v-on:click="sortFunction('createdAt')">Info Rec C Time</th>
                      <th class="header-cell w7" v-on:click="sortFunction('createdAt')">Info Rec C Diff Time</th>
                      <th class="header-cell w7" v-on:click="sortFunction('createdAt')">Info Rec U Date</th>
                      <th class="header-cell w7" v-on:click="sortFunction('createdAt')">Info Rec U Time</th>
                      <th class="header-cell w7" v-on:click="sortFunction('createdAt')">Info Rec U Diff Time</th>
                      <th class="header-cell w5" v-on:click="sortFunction('createdBy')">Create Person</th>
                      <th class="header-cell w5" v-on:click="sortFunction('createdAt')">Create Date</th>
                      <th class="header-cell w5" v-on:click="sortFunction('createdAt')">Create Time</th>
                      <th class="header-cell w5" v-on:click="sortFunction('updatedBy')">Change Person</th>
                      <th class="header-cell w5" v-on:click="sortFunction('updatedAt')">Change Date</th>
                      <th class="header-cell w5" v-on:click="sortFunction('updatedAt')">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.logId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <!--<td class="body-cell w2">
                        <md-button @click="toggleRemove(item)" class="md-icon-button">
                          <md-icon>delete</md-icon>
                        </md-button>
                      </td>-->
                      <!--<td class="body-cell w9">{{item.tagId}}</td>-->
                      <th class="header-cell w4">{{item.logId}}</th>
                      <th class="header-cell w4">{{item.yard}}</th>
                      <th class="header-cell w4">{{item.gateTypeDesc}}</th>
                      <th class="header-cell w4">{{item.gateNo}}</th>
                      <th class="header-cell w5">{{item.statusTypeDesc}}</th>
                      <th class="header-cell w4">{{item.logDateTime | date}}</th>
                      <th class="header-cell w4">{{item.logDateTime | time}}</th>
                      <th class="header-cell w7">{{item.plateNo}}</th>
                      <!--<th class="header-cell w10">{{item.plateImage}}</th>-->
                      <th class="header-cell w7">
                        <template v-if="item.plateImage != null && item.plateImage != '' && item.plateImage != 'X'">
                          <!--<a href="" @click.prevent="toggleItemLink(item,'P')">-->
                          <a href="" @click.prevent="toggleItemLink1(item,'P')">  
                            1 image
                          </a>  
                        </template>  
                        <template v-else>
                            0 image
                        </template>  
                      </th>  
                      <th class="header-cell w7">{{item.containerNo}}</th>
                      <th class="header-cell w6">{{item.containerType}}</th>
                      <th class="header-cell w6">{{getMasterDataByName("CCR_CNTRTYPE",item.containerType)}}</th>
                      <th class="header-cell w6">{{getMasterDataByName("CCR_CNTRTYPE_ID",item.containerType)}}</th>
                      <!--<th class="header-cell w10">{{item.containerImage}}</th>-->
                      <th class="header-cell w7">
                        <template v-if="item.containerImage != null && item.containerImage != '' && item.containerImage != 'X'">
                          <!--<a href="" @click.prevent="toggleItemLink(item,'C')">-->
                          <a href="" @click.prevent="toggleItemLink1(item,'C')">  
                            1 image
                          </a>  
                        </template>  
                        <template v-else>
                            0 image
                        </template>  
                      </th>  
                      <th class="header-cell w7">{{item.chassisNo}}</th>
                      <!--<th class="header-cell w10">{{item.chassisImage}}</th>-->
                      <th class="header-cell w7">
                        <template v-if="item.chassisImage != null && item.chassisImage != '' && item.chassisImage != 'X'">
                          <a href="" @click.prevent="toggleItemLink1(item,'CH')">  
                          <!--<a href="" @click.prevent="toggleItemLink(item,'CH')">-->
                            1 image
                          </a>  
                        </template>  
                        <template v-else>
                            0 image
                        </template>  
                      </th>  
                      <th class="header-cell w6">{{item.scaleWeight}}</th>
                      <th class="header-cell w5">{{item.logStatus}}</th>
                      <th class="header-cell w10">{{getMasterDataByName("CCR_STATUS2",item.status)}}</th>
                      <th class="header-cell w7">{{item.inboundShipment}}</th>
                      <th class="header-cell w7">{{item.seqNo}}</th>
                      <th class="header-cell w10">{{item.containerNoSource}}</th>
                      <th class="header-cell w10">{{item.plateNoSource}}</th>
                      <th class="header-cell w10">{{item.chassisNoSource}}</th>
                      <td class="body-cell w7">{{item.infoRecCreateAt | date}}</td>
                      <td class="body-cell w7">{{item.infoRecCreateAt | time}}</td>
                      <td class="body-cell w7">{{getLogDiffTime(item,'C')}}</td>
                      <td class="body-cell w7">{{item.infoRecUpdateAt | date}}</td>
                      <td class="body-cell w7">{{item.infoRecUpdateAt | time}}</td>
                      <td class="body-cell w7">{{getLogDiffTime(item,'U')}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </md-card>

        </template>
      </pagination>
    </callingApiCenter>
  </div>

</template>
<style scoped>
.heading2 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 26px;
    font-family: Roboto Slab;
    margin: auto;
  }

.inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 5px 5px 5px 5px;
    margin-top: 5px;
}

.inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 6px 6px 6px 6px;
    margin-top: 5px;
    background-color: #e0eff7;
      
}

.input[type=checkbox] {
  position: relative;
  cursor: pointer;
}
input[type=checkbox]:before {
  content: "";
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  top: 0;
  left: 0;
  border: 2px solid #555555;
  border-radius: 3px;
  background-color: white;
}
input[type=checkbox]:checked:after {
  content:"";
  display: block;
  width:5px;
  height: 10px;
  border: solid black;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 2px;
  left: 6px;
}

.inputBoxSpace {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 200px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
.inputBoxDouble {
    /* border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px; */
    width: 400px;
    justify-content: space-around;
    display: flex;
  flex-direction: row;
  }
  .inputBoxInbound {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
  
  .inputBoxInbound:hover {
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
    background-color: #e0eff7;
  }

  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-size: 23px;
    display: inline-block;
    background-color: lightgray;
    margin-left: 300px;
    margin-top: 15px;
    -moz-osx-font-smoothing: grayscale;
  }
  #divider {
    height: 50px;
    width: 5px;
    background-color: black;
    display: inline-block;
  }
  .optionExtender {
    margin-left: 300px;
  }
  .optionExtender:hover{opacity:0.5};
  .searchTagName {
    margin-top: -15px;
    margin-left: 50px;
    display: inline-block;
  }
  .search {
    margin-left:10px;
  }
  .search2 {
    margin-left:100px;
  }
  .space {
  margin-top: 20px;
  margin-bottom: 10px;
  }
  .f1 {
    position: relative;
    margin-left:25px;
  }
  .c2r1 {
    position: relative;
    margin-top: -66px;
    margin-left: 208px;
    width: 200px;
  }
  .c3r1 {
    position:relative; 
    margin-left:415px; 
    margin-top:-66px; 
    width:200px;
  }
  .c4r1 {
    position:relative; 
    margin-left:620px; 
    margin-top:-66px; 
    width:200px;
  }
  .c5r1 {
    position:relative; 
    margin-left:825px; 
    margin-top:-66px; 
    width:200px;
  }
  .c1r2 {
    position:relative; 
    margin-left:1030px; 
    margin-top:-66px; 
    width:200px;
  }
  .c2r2 {
    position:relative; 
    margin-top:10px; 
    width:200px; 
    position:relative;
  }
  .c3r2 {
    position:relative; 
    margin-top:-66px; 
    margin-left:208px;
    width:200px;
  }
  .c4r2 {
    position:relative; 
    margin-top:-66px; 
    margin-left:415px;
    width:200px;
  }
  .c5r2 {
    position:relative; 
    margin-top:-66px; 
    margin-left:620px;
    width:200px;
  }
  .c6r2 {
    position:relative; 
    margin-top:-66px; 
    margin-left:825px;
    width:200px;
  }
  .f2 {
    margin-top:15px; 
    margin-left:30px; 
    width:500px; 
    position:relative;
  }
  .f3 {
    margin-top: 10px; 
    margin-bottom: 5px;
    margin-left: -20px;
    position:relative;
  }
  .f4 {
    margin-top:15px; 
    margin-left:-90px; 
    position:relative;
  }
  .f5 {
    margin-top:15px; 
    margin-left: -260px;
    position:relative;
  }
  .gap {
    margin-left: 20px;
  }  
</style>
<script>
  import CcrLogForm from '../components/CCRLogForm.vue';
  import CcrLogUpdateForm from '../components/CCRLogForm.vue';
  import sort from "fast-sort";
  import MasterDataForm from '../components/MasterDataForm.vue';
  //import TemplateApptForm from '../components/TemplateApptForm.vue';
  import MasterDataSelectForm from '../components/MasterDataSelectForm.vue';
  //import TemplateApptUpdateForm from '../components/TemplateApptForm.vue';
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
import dateFormat from '../utils/dateFormat';

  const getInitialDataForm = () => ({
    logId: null,
    yard: null,
    gateType: null,
    gateNo: null,
    statusType: null,
    logDate: null,
    logTime: null,
    plateNo: null,
    plateImage: null,
    containerNo: null,
    containerType: null,
    containerImage: null,
    chassisNo: null,
    chassisImage: null,
    scaleWeight: null,
    logStatus: null,
    inboundShipment: null 
  });

  const getInitSaveForm = () => ({
    logId: null,
    yard: null,
    gateType: null,
    gateNo: null,
    statusType: null,
    logDateTime: null,
    plateNo: null,
    plateImage: null,
    containerNo: null,
    containerType: null,
    containerImage: null,
    chassisNo: null,
    chassisImage: null,
    scaleWeight: null,
    logStatus: null,
    inboundShipment: null 
  });

  const getInitSearchRequest = () => ({
    yard: null,
    gateType: null,
    gateNo: null,
    statusType: null,
    logDateTime: {
      startDate: null,
      endDate: null
    },
    plateNo: null,
    containerNo: null,
    containerType: null,
    chassisNo: null,
    logStatus: null,
    inboundShipment: null
  });

  const devImgPath = "https://named-account-web-dev.s3.us-west-2.amazonaws.com/";
  const qasImgPath = "https://named-account-web-qas.s3.us-west-2.amazonaws.com/";
  const prdImgPath = "https://named-account-web-prd.s3.us-west-2.amazonaws.com/";

  export default {
    data: () => ({
      DataForm: getInitialDataForm(),
      searchRequest: getInitSearchRequest(),
      SaveForm: getInitSaveForm(),
      selectedItem: [],
      items: [],
      ccrLog: [],
      photos: [],
      showOnlyProblem: false,
      logStartDate: moment().toDate(),
      logEndDate: null,
      active: true,
      isPictureModalShowing: false,
      photoZipFileName: '',
      filePrefixForEachFile: '',
      isLoading: false,
      isdownloadzip: false,
      imgPath: null,
      photoTitle: "Photos"

    }),
    components: {
      CcrLogForm,
      CcrLogUpdateForm,
      MasterDataForm,
      MasterDataSelectForm,
      callingApiCenter,
    },
    computed: {
      ...mapGetters([
         'getCCRLog',
         'getMasterDataName',
         "getPermission"
      ]),
      filteredRows(){
        return _(this.items).sortBy((it) => {it.logId}).reverse();
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

      canEdit() {
        return this.getSelectedItems.length === 1 ;
      },

      // getCCRLog() {
      //   return this.ccrlog;
      // },  

      filteredMasterDatasByActive() {
        if (this.showOnlyProblem) {
          return _(this.masterDatas)
            .filter(it => it.active);
        }
        return this.masterDatas;
      },
      getAllMasterGroups() {
        console.log("getAllMasterGroups");
        return _(this.filteredMasterDatasByActive || [])
          .chain()
          .pluck('group')
          .uniq()
          .sortBy(it => it)
          .value();
      },
      getFilteredMasterDatas() {
        //this.isload = false;
        console.log(JSON.stringify(this.searchRequest));
        if (!this.DataForm.tagId)
           this.DataForm.tagId = '';
        if (!this.DataForm.tagName)
           this.DataForm.tagName = '';

        console.log("getFilteredMasterDatas tagId: " + this.DataForm.tagId);
        console.log("getFilteredMasterDatas tagName: " + this.DataForm.tagName);
     



  
        console.log("getFilteredMasterDatas isLoad: " + this.isload);
        if (this.isload)
        {
           console.log("tagId: " + this.DataForm.tagId.toString());
           console.log("tagName: " + this.DataForm.tagName.trim());
           console.log("transloadyard: " + this.DataForm.transloadingYard);
           console.log("recWindow: " + this.DataForm.recWindow);
           return  _(this.filteredMasterDatasByActive)
            .filter(it => (((this.selectedGroup) && (it.group === this.selectedGroup)) || ((!this.selectedGroup) && (it.group !== null)))
                  && (((this.DataForm.tagId !== '') && (it.tagId.includes(this.DataForm.tagId))) || ((this.DataForm.tagId === '') && (it.tagId !== null)))
                  //&& (((this.DataForm.recWindow !== '') && (it.recWindow.includes(this.DataForm.recWindow))) || ((this.DataForm.recWindow === '') || (it.recWindow != null)))
                  && ( this.DataForm.recWindow == null || it.recWindow === this.DataForm.recWindow.toString())
                  && (((this.DataForm.tagName !== '') && (it.tagName.trim().includes(this.DataForm.tagName.trim()))) || ((this.DataForm.tagName === ''))   )
            )
                     
        }
        else
        {
          console.log("isLoad is false: " + this.isload);
          if (this.selectedGroup)
           return _(this.filteredMasterDatasByActive)
               .filter(it => it.group === this.selectedGroup);
          else
           return _(this.filteredMasterDatasByActive);
        }

      },
      getSortedMasterDatas() {
          return _(this.getFilteredMasterDatas)
            .sortBy(it => it.to);
      },
      
      getDownloadCond() {
          const item = _(this.items).filter((it) => it.selected);
          if (item.length == 0 && this.items.length != 0) return this.items;

      },
      

    },
    watch: {
      getCCRLog(val) {
         this.updateItems(val);
      },

        //}
        //this.isload = false;
      masterDatas() {
        this.$nextTick(() => {
          this.updateTableHeight();
        });
      },
    },
    async mounted() {
      //await this.reload();
      const cachedSearchRequest = this.searchRequest;
      if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      } else {
         this.searchRequest = getInitSearch(this);
      }
    },
    methods: {

      async reload() {
        //const masterDatas = await api.post('/api/w/ccr/data/getCCRLog',
        //{

        //});
        //this.masterDatas = masterDatas;
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },
      // handleWindowsChanged(id) {
      //   console.log("rec win: " + id);
      //   this.DataForm.recWindow = id;
      // },

      handleYardChanged(id) {
        console.log("yard: " + id);
        this.DataForm.yard = id;
        this.searchRequest.yard = id;
      },

      handleGateTypeChanged(id) {
        console.log("gate type: " + id);
        this.DataForm.gateType = id;
        this.searchRequest.gateType = id;
      },

      handleStatusTypeChanged(id) {
        console.log("status type: " + id);
        this.DataForm.statusType = id;
        this.searchRequest.statusType = id;
      },

      handleContainerTypeChanged(id) {
        console.log("container type: " + id);
        this.DataForm.containerType = id;
        this.searchRequest.containerType = id;
      },

      getMasterDataByName(group, tagId) {
        //console.log("get master data name: " + group + ", " + tagId);
        if (!tagId) {
          return "";
        }
        //console.log("master name: " + this.getMasterDataName(group, tagId));
        return this.getMasterDataName(group, tagId);
        //return "";
      },

      getLogDiffTime(item,type) {
        const logdatetime = new Date(item.logDateTime);
        const createdatetime = new Date(item.createdAt);
        const updatedatetime = new Date(item.updatedAt);
        const logtime = logdatetime.getTime();
        const createtime = createdatetime.getTime();
        const updatetime = updatedatetime.getTime();
        const retVal_C = (createtime - logtime) / 1000;
        const retVal_U = (updatetime - logtime) / 1000;
        console.log("log date time: " + logdatetime + ", createdatetime: " + createdatetime + ", updatedatetime" + updatedatetime);
        console.log("log time: " + logtime + ", createtime: " + createtime + ", updatetime" + updatetime);
        if (type == "C") {
           console.log("log date time c diff: " + retVal_C);
           if (createtime == 0) 
             return "";
           else
             return retVal_C + " s";
        } else if (type == "U") {
          console.log("log date time u diff: " + retVal_U);
          if (updatetime == 0)
            return "";
          else  
            return retVal_U + " s";
        } else {
          return "";
        }
      },

      toggleUpdate(item) {
        this.$refs.CcrLogUpdateForm.openDialog(item);
      },
      toggleRemove(item) {
        
      },
      doNew() {
        this.$refs.CcrLogForm.openDialog();
      },

      updateCCRlog(log) {
        var items = JSON.parse(JSON.stringify(log));
        this.ccrlog = items;
      },
      
      updateItems(itemsSource) {
        console.log("update items");
        var items = JSON.parse(JSON.stringify(itemsSource));
        items.forEach((it) => {
        //   it.backGroud = false;
        //   it.selected = false;
        //   it.editing = false;
            it.gateTypeDesc = this.getMasterDataName("CCR_GATETYPE", it.gateType);
            it.statusTypeDesc = this.getMasterDataName("CCR_STATUSTYPE", it.statusType);
         });
        this.items = items;
      },

      getPhotoName(photo) {
          const photoName = decodeURI(photo.imgUrl.replace(/.*\//g, ""));
          return `${this.filePrefixForEachFile || ''}${photoName}`;
      },

      async toggleItemLink(item,imgType) {
          this.isPictureModalShowing = true;
          this.isLoading = true;
          //this.photos = (await api.post('/api/w/ccr/photo/getCCRPhoto', { logId: item.logId, imageType: imgType }));
          this.photos = (await newAPIPost('/api/w/ccr/photo/getCCRPhoto', { logId: item.logId, imageType: imgType }));
          console.log("photos length: " + this.photos.length);
          console.log("item: " + JSON.stringify(item));
          if (item.logId != null)
             this.photoZipFileName = `${item.logId}_${item.plateNo}.zip`;
          else
             this.photoZipFileName = `${item.logId}_` + imgType + `.zip`;
          this.filePrefixForEachFile = `${item.plateNo}-`;
          if (imgType == "P")
             this.photoTitle = "Plate# Image";
          if (imgType == "C")
             this.photoTitle = "Container# Image";
          if (imgType == "CH")
             this.photoTitle = "Chassis# Image";        
          console.log(this.photos)

      },
      
      toggleItemLink1(item,imgType) {
        var mylink = "";
        var title = "";
        var width;
        var height;
        var leftPos;
        var topPos;
        var settings = "";
        var userWidth = screen.availWidth;
        var userHeight = screen.availHeight;

        width =  400;
        height = 200;
        //leftPos = (userWidth - width) /2;
        //leftPos = 1500;
        leftPos = userWidth - 500;
        topPos = (userHeight - height) /2;
        console.log("leftPos: " + leftPos + " topPos: " + topPos);
        console.log("avail height: " + userHeight + " avail width: " + userWidth);
        settings += 'left=' + leftPos + ',top=' + topPos + ',width=' + width + ',height=' + height;
        settings += ',scrollbars=yes';
        console.log("settings: " + settings);
        if (imgType == "P") {
             title = "Plate# Image";
             mylink = item.plateImage;
        }    
          if (imgType == "C") {
             title = "Container# Image";
             mylink = item.containerImage;
          }
          if (imgType == "CH") {
             title = "Chassis# Image";
             mylink = item.chassisImage;
          }        
        if (! window.focus)return true;
           var href;
        if (typeof(mylink) == 'string') href=mylink;
        else href=mylink.href; 
        //window.open(href, title, 'width=400,height=200,scrollbars=yes'); 
        console.log("href: " + href);
        if (href.toString().indexOf('http') < 0) {
           console.log("index: " + href.toString().indexOf('http'));
           alert("Not a valid picture path");
        }   
        else {
          window.open(href, title, settings,true);
        }
        return false; 

      },



      doSearch() {
        var checked = false;
        this.active = false;
        console.log("yard: " + this.searchRequest.yard);
        console.log("gateType: " + this.searchRequest.gateType);
        console.log("original start date: " + this.logStartDate);
        console.log("original end date: " + this.logEndDate);
        //this.searchRequest.logDateTime.startDate = this.logStartDate;
        //this.searchRequest.logDateTime.endDate = this.logEndDate;
        if (this.logStartDate != null || this.logEndDate != null) {
          if (this.logEndDate == null || this.logEndDate == ""){
             this.searchRequest.logDateTime.endDate = formatLogDate(this.logStartDate, false);   
          } else {
             this.searchRequest.logDateTime.endDate = formatLogDate(this.logEndDate, false);
          }
          if (this.logStartDate)
             this.searchRequest.logDateTime.startDate = formatLogDate(this.logStartDate, true);
          if (this.searchRequest.logDateTime.startDate > this.searchRequest.logDateTime.endDate) {
             alert("Error: Search Start Date is greater than End Date");
             return;
          } 
        } 
        console.log("only show issue: " + this.showOnlyProblem);
        console.log("start date: " + this.searchRequest.logDateTime.startDate);
        console.log("end date: " + this.searchRequest.logDateTime.endDate);
        if (document.getElementById("showOnlyProblem")) {
           if (document.getElementById("showOnlyProblem").checked == true)
               checked = true;
           console.log("checkbox checked status from ID: " + document.getElementById("showOnlyProblem").checked);
           console.log("checkbox checked status from value: " + document.getElementById("showOnlyProblem").value);
           console.log("checkbox checked status: " + checked);
        }
        if (this.showOnlyProblem == true || checked)
           this.searchRequest.logStatus = "X";
        else
           this.searchRequest.logStatus = null;

        this.$nextTick(() => {
          this.$store.dispatch('ccrLog', this.searchRequest);
        })
        
      },
      doClear() {
        this.isload = false;
        //console.log("tagId: " + document.getElementById("tagId").innerHTML);
        //console.log("tagId value: " + document.getElementById("tagId").value);
        //console.log("tagName value: " + document.getElementById("tagName").value);
        console.log("doClear isload: " + this.isload);
        //this.selectedGroup = "T_APP_MASTER";
        //this.DataForm.group = "T_APP_MASTER";
        //this.DataForm.tagId = '';
        //this.DataForm.tagName = '';

        this.DataForm = getInitialDataForm();         
        this.searchRequest = getInitSearchRequest();
        //this.handleWindowsChanged(null);
         _(this.$el.querySelectorAll('button.md-input-action.md-clear')).each((it) => {
           it.click();
         });

        console.log(this.DataForm);
      },

      async updateLog(logInfo)
      {
        if (logInfo)
        {
           console.log("logInfo-logId: " + logInfo.logId);
           console.log("logInfo-yard: " + logInfo.yard);
           console.log("logInfo-gateType: " + logInfo.gateType);
           console.log("logInfo-gateNo: " + logInfo.gateNo);
           console.log("logInfo-statusType: " + logInfo.statusType);
           console.log("logInfo-logDateTime: " + logInfo.logDateTime);
           console.log("logInfo-plateNo: " + logInfo.plateNo);
           console.log("logInfo-containerNo: " + logInfo.containerNo);
           console.log("logInfo-containerType: " + logInfo.containerType);
           console.log("logInfo-chassisNo: " + logInfo.chassisNo);
           console.log("logInfo-scaleWeight: " + logInfo.scaleWeight);
           console.log("logInfo-plateImage: " + logInfo.plateImage);
           console.log("logInfo-containerImage: " + logInfo.containerImage);
           console.log("logInfo-chassisImage: " + logInfo.chassisImage);
           console.log("logInfo-inboundShipment: " + logInfo.inboundShipment);
           console.log("logInfo-seqNo: " + logInfo.seqNo);
        }
        var selectedItem = _(this.items).find(it => it.logId == logInfo.logId)
        console.log("selecteditem: " + selectedItem);
        if (selectedItem != null)
        {
           selectedItem.yard = logInfo.yard;
           selectedItem.gateType = logInfo.gateType;
           selectedItem.gateNo = logInfo.gateNo;
           selectedItem.statusType = logInfo.statusType;
           selectedItem.logDateTime = logInfo.logDateTime;
           selectedItem.plateNo = logInfo.plateNo;
           selectedItem.containerNo = logInfo.containerNo;
           selectedItem.containerType = logInfo.containerType;
           selectedItem.chassisNo = logInfo.chassisNo;
           selectedItem.scaleWeight = logInfo.scaleWeight;
           selectedItem.inboundShipment = logInfo.inboundShipment;
           selectedItem.seqNo = logInfo.seqNo;
           selectedItem.plateImage = logInfo.plateImage;
           selectedItem.containerImage = logInfo.containerImage;
           selectedItem.chassisImage = logInfo.chassisImage;
           if (logInfo.plateNo == "X" || logInfo.containerNo == "X"
                 || logInfo.chassisNo == "X")
              selectedItem.logStatus = "X";
           else 
              selectedItem.logStatus = "";
        }
      },

      doDownload() {
        this.downloading = true;
        const zipFileName = this.zipFileName || 'pictures.zip';
        const promises = _(this.testphotos)
          .map((photo) => {
            const a = document.createElement('a');
            a.href = photo.photoUrl;

            const req = {
              method: 'GET',
              mode: 'no-cors',
              cache: 'default',
            };

            const pathName = a.pathname;
            console.log(pathName);
            return fetch(pathName, req)
              .then(response => ({
                response,
                photo,
              }));
          });


        Promise.all(promises)
          .then((results) => {
            this.downloading = false;
            console.log(`aa`, results);
            const zip = new JSZip();
            _.chain(results)
              .groupBy(it => it.photo.containerNo)
              .each((values, k) => {
                console.log(values[0].photo.bookingNo)
                const target = (`${k}` !== `null`) ? zip.folder(k) : zip;
                _(values)
                  .each(({ response,photo }) => {
                    const res = response;
                    let filename = photo.containerNo + "-" + decodeURI(res.url.replace(/.*\//g, ""));
                    if (!filename.endsWith('png') || !filename.endsWith('jpg')) {
                      filename += '.png';
                    }
                    console.log(`filename=${filename}`);
                    const blob = res.blob();
                    target.file(filename, blob, { binary: true });
                  });
              });

            zip.generateAsync({ type: "blob" })
              .then((blob) => {
                const a = $("<a style='display: none;'/>");
                const url = window.URL.createObjectURL(blob);
                a.attr("href", url);
                a.attr("download", zipFileName);
                $("body")
                  .append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
                this.isdownloadzip = false;
              });
          })
          .catch((e) => {
            console.error(e);
            this.downloading = false;
            this.isdownloadzip = false;
          });
      },

      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

      sortFunction(sortFiled) {
        const sorted = sort(this.items).asc(sortFiled);
        this.sortStatus = !this.sortStatus;
        if (this.sortStatus) {
          this.items = sorted;
        } else {
          this.items = sorted.reverse();
        }
      },

      doDownloadExcel(){
       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'CCRLog.xls',
          1,
        );
          //request.heads = _(request.heads).take(52);
          request.heads = _(request.heads).take(27);
          request.rows = _(this.items)
          .map(item => [
            item.logId,
            item.yard,
            item.gateTypeDesc,
            item.gateNo,
            item.statusTypeDesc,
            dateFormat.date(item.logDateTime),
            dateFormat.time(item.logDateTime),
            item.plateNo,
            item.plateImage,
            item.containerNo,
            item.containerType,
            this.getMasterDataByName("CCR_CNTRTYPE",item.containerType),
            this.getMasterDataByName("CCR_CNTRTYPE_ID",item.containerType),
            item.containerImage,
            item.chassisNo,
            item.chassisImage,
            item.scaleWeight,
            item.logStatus,
            item.status,
            item.inboundShipment,
            item.seqNo,
            item.createdBy,
            dateFormat.date(item.createdAt),
            dateFormat.time(item.createdAt),
            item.updatedBy,
            dateFormat.date(item.updatedAt),
            dateFormat.time(item.updatedAt),

          ]);
        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },

    },
  };

function formatLogDate(date, startdate) {
  console.log("formatEndDate::date: " + date);
  if (date) {
     var year = date.getFullYear();
     var month = date.getMonth();
     var day = date.getDate();
     month += 1;
     if (month < 10)
        month = "0" + month;
     if (day < 10)
        day = "0" + day;
     console.log("month: " + month);
     if (startdate == true)
        return year + "-" + month + "-" + day + "T00:00:00";
     else
        return year + "-" + month + "-" + day + "T23:59:59";
  } else {
     return "";
  }
}
</script>
